import { getLiteAppPath } from '@components/LocalMerchant/LiteApp/util'
import { PATH_ZGT } from '@components/LocalMerchant/ZhiGuangTong/constant'
import { isShowZhiGuangTong } from '@components/LocalMerchant/ZhiGuangTong/util'
import { PATH_ZTB } from '@components/LocalMerchant/ZhiTuiBao/constant'
import { isShowZhiTuiBao } from '@components/LocalMerchant/ZhiTuiBao/util'
import {
  ACTIVITY_DIY_PATH_A,
  APPRAISE_LIST_PATH_A,
  BOND_PATH_A,
  COUPONS_PATH_A,
  EDIT_STORE_PATH_A,
  JUKE_PATH_A,
  LIVE_MANAGE_PATH_A,
  MARKETING_CENTER_PATH_A,
  MARKETING_PRODUCT_DETAIL_PATH_A,
  NAME_CARD_MANAGE_PATH_A,
  PRODUCT_COUPONS,
  SHOP_PRODUCTS_PATH_A,
  WATER_STORE_PATH
} from '@constant'
import { dGet } from '@core/utils'
import { isUltimate } from '@merchant-backend/util'
import {
  getJtiPath,
  getNameCardRight,
  HLJ_STATISTIC,
  statisticPoster
} from '../..'

export const getZhiTuiBaoPath = () => {
  if (isShowZhiTuiBao()) {
    return `#${PATH_ZTB}`
  }

  return false
}

export const getZhiGuangTongPath = () => {
  if (isShowZhiGuangTong()) {
    return `#${PATH_ZGT}`
  }

  return false
}

export const getSpecialCouponPath = () => {
  return isUltimate()
    ? `${COUPONS_PATH_A}/detail?type=2`
    : `${MARKETING_PRODUCT_DETAIL_PATH_A}/${PRODUCT_COUPONS}`
}

export const getLivePath = () => {
  return LIVE_MANAGE_PATH_A
}

/**
 * 获取海草名片的跳转路径
 */
export const getNameCardPath = async () => {
  HLJ_STATISTIC({
    element_tag: 'merchant_business_card',
    event_type: 'element_hit',
    page_name: '首页'
  })
  return (await getNameCardRight())
    ? NAME_CARD_MANAGE_PATH_A
    : `${MARKETING_PRODUCT_DETAIL_PATH_A}/911`
}

/**
 *
 * @param {Object} data 接口返回 poster 数据
 * @param {String} key 坑位
 */
export const getPosterByKey = (data, key) => {
  const holes = dGet(data, `floors.${key}.holes`, [])
  return dGet(holes[0], 'posters', {})
}

/**
 *  poster 跳转统一方法
 */
export const gotoPoster = async poster => {
  const { id, target_id, target_url, target_type } = poster || {}
  // 埋点
  statisticPoster(id)

  // http://172.16.10.4:8090/pages/viewpage.action?pageId=5832921
  if (target_type == 9) {
    window.open(target_url)
  } else {
    const targetObj = {
      '58': `${APPRAISE_LIST_PATH_A}/questionAndAnswer/${target_id}`, // 问题详情
      '100': '#/localMerchant/myShop', // 商家等级页
      '101': MARKETING_CENTER_PATH_A, // 营销管理页
      '102': EDIT_STORE_PATH_A, // 编辑店铺页
      '103': '', // 日程管理
      '104': '', // 生意罗盘
      '106': JUKE_PATH_A, // 聚客宝
      '107': '', // 互动
      '108': '#/localMerchant/easyChat',
      '233': SHOP_PRODUCTS_PATH_A, // 商家旗舰版 ？？
      '279': SHOP_PRODUCTS_PATH_A, // 旗舰版
      '280': getZhiTuiBaoPath(), // 智推宝
      '281': getZhiGuangTongPath(), // 智优投
      '282': getLiteAppPath('hash'), // 小程序
      '283': ACTIVITY_DIY_PATH_A, // 微传单+
      '284': getJtiPath(WATER_STORE_PATH), // 水镜
      '300': BOND_PATH_A, // 放心购
      '2001': '#/localMerchant/activityRegister',
      '2002': `#/localMerchant/activityRegister/activityDetail/${target_id}`,
      '2003': getSpecialCouponPath(), // 特殊专享券
      '2004': `${LIVE_MANAGE_PATH_A}/purchase`, // 直播购买
      '2006': getLivePath(), // 直播营销
      '2016': getNameCardPath(), // 海草名片路由
      '2007': `${LIVE_MANAGE_PATH_A}/reportFormSuperCase` // 直播提报单详情页poster
    }

    const path = await targetObj[String(target_type)]

    path && window.open(path)
  }
}
